import React from 'react';
import MediaImage from './MediaImage';

type AvatarImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  position?: { x: number; y: number; scale: number };
  sizeClass?: string;
};

/**
 * User avatar — square source, circular presentation, optional position nudge from upload UI.
 */
export const AvatarImage: React.FC<AvatarImageProps> = ({
  src,
  alt,
  className = '',
  position,
  sizeClass = 'w-full h-full',
}) => {
  const transform = position
    ? `translate(${position.x}px, ${position.y}px) scale(${position.scale})`
    : undefined;

  return (
    <div className={`overflow-hidden rounded-full bg-[#141414] ${className}`}>
      <div className={sizeClass} style={{ transform, transformOrigin: 'center center' }}>
        <MediaImage src={src} alt={alt} fit="cover" loading="eager" className="w-full h-full" />
      </div>
    </div>
  );
};

export default AvatarImage;
